import { Button } from '../../../../../core/components/atoms/Button';
import { Typography } from '../../../../../core/components/molecules/Typography';
import { Modal } from '../../../../../core/components/templates/Modal';

interface iStartSimulationModalProps {
  isOpen: boolean;
  onClose: () => void;
  questionsCount: number;
  timeToFinish: string;
  isStartButtonLoading: boolean;
  handleStart: () => void;
}

export default function StartSimulationModal({
  isOpen,
  onClose,
  questionsCount,
  timeToFinish,
  isStartButtonLoading,
  handleStart,
}: iStartSimulationModalProps) {
  return (
    <Modal
      position='center'
      size='md'
      isOpen={isOpen}
      onClose={() => onClose()}
      className='xs:w-full md:w-2/5'
    >
      <div className='flex flex-col gap-xl'>
        <Typography size='default' weight='bold'>
          Instruções para o simulado
        </Typography>
        <ul className='list-inside'>
          <li>
            <Typography className='list-item list-disc'>
              Você terá{' '}
              <b>
                {timeToFinish} para resolver {questionsCount}{' '}
                {questionsCount > 1 ? 'questões' : 'questão'}
              </b>
              . Ao final você poderá ver as questões que errou com a resolução
              correta. <b>Não é possível parar o simulado!</b> O tempo
              continuará correndo até que você encerre o simulado ou o tempo se
              esgote;
            </Typography>
          </li>
          <li>
            <Typography className='list-item list-disc'>
              As respostas podem ser <b>objetivas ou somatórias</b>. Nas
              somatórias você só pontua se marcar todas as corretas e não marcar
              nenhuma incorreta.
            </Typography>
          </li>
        </ul>
        <div className='flex flex-row justify-end gap-sm'>
          <Button variant='text' onClick={() => onClose()}>
            Voltar
          </Button>
          <Button
            variant='contained'
            onClick={handleStart}
            loading={isStartButtonLoading}
          >
            Iniciar simulado
          </Button>
        </div>
      </div>
    </Modal>
  );
}
